import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController, AlertController, ToastController } from '@ionic/angular';
import { TermsComponent } from '@shared/components/terms/terms.component';
import { AuthenticationService } from '@shared/services/authentication.service';
import { UtilService } from '@shared/utils/util';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserModel } from '@shared/models/user.model';
import { LocationService } from '@shared/services/location.service';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { UserService } from '@shared/services/user.service';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
import { HttpClient } from '@angular/common/http';
import { FcmService } from '@shared/services/fcm.service';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Capacitor } from '@capacitor/core';
import { AppComponent } from 'src/app/app.component';
import { LoginSharedPage } from '../login-shared/login-shared.page';
import { PushNotifications } from '@capacitor/push-notifications';
import { FirebaseCrashlyticsService } from '@shared/services/firebase-crashlytics.service';
import { environment, webVersion } from 'src/environments/environment';
import { FacebookService } from '@shared/services/facebook.service';
import { FacebookUser } from '@shared/interfaces/facebook-user-interface';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import { MatchService } from 'src/app/services/match.service';
import { SignInWithApple, SignInWithAppleResponse, SignInWithAppleOptions } from '@capacitor-community/apple-sign-in';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  providers: [UtilService],
})
export class LoginPage implements OnInit {
  public isNative: boolean = this.util.isNative();
  public isIos: boolean = true;
  public isIpad: boolean = false;
  public isTablet: boolean = false;
  public deviceInfo: any;
  public userData: any = {}; // Initialize with an empty object
  public imageFB: string = '';
  public processingAppleSignin: boolean = false;
  public processingGoogleSignin: boolean = false;
  public processingFacebookSignin: boolean = false;

  public userLoggedIn: boolean = false;
  constructor(
    private fcm: FcmService,
    private facebookService: FacebookService,
    private http: HttpClient,
    private userModel: UserModel,
    public analytics: AnalyticsService,
    private authenticationService: AuthenticationService,
    private modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    private util: UtilService,
    private alertCtrl: AlertController,
    public platform: Platform,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    private userService: UserService,
    private locationService: LocationService,
    public firebaseCrashlytics: FirebaseCrashlyticsService,
    public router: Router,
    private matchService: MatchService
  ) {
    this.util.initTranslate();
    this.userModel = new UserModel();
    this.isNative = this.util.isNative();
    this.isIos = !platform.is('android');
    this.isIpad = platform.is('ipad') || (platform.is('ios') && window.innerWidth >= 768);
    this.isTablet = this.isIpad || (platform.is('android') && window.innerWidth >= 768);
    this.initializeApp();
    //this.startVideo();
  }

  async ionViewWillEnter() {
    this.userLoggedIn = localStorage.getItem('USER_LOGGED') ? true : false;

    this.util.initTranslate();

    if (localStorage.getItem('USER_LOGGED')) {
      this.router.navigateByUrl('/tabs/home');
      return;
    }

    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      this.userData = val;
      //this.ensureTerms();
    });

    // this.startVideo();
  }

  async ionViewDidEnter() {
    // Request push notification permission directly in login page for Android
    if (this.isNative && !this.userLoggedIn) {
      // Wait for UI to be ready
      setTimeout(async () => {
        try {
          // For Android, request permission directly here if not already requested
          if (this.platform.is('android')) {
            const deviceInfo = await Device.getInfo();
            const osVersion = parseInt(deviceInfo.osVersion);
            
            // Android 13+ requires explicit permission request
            if (osVersion > 12) {
              await this.registerNotifications();
            } else {
              // For Android <= 12, just try to register
              try {
                await PushNotifications.register();
                console.log('Push notifications registered for Android <= 12');
              } catch (error) {
                console.error('Error registering push notifications for Android <= 12:', error);
              }
            }
          } else {
            // For iOS, check if permission was already granted and register
            const permStatus = await PushNotifications.checkPermissions();
            if (permStatus.receive === 'granted') {
              await PushNotifications.register();
              console.log('Push notifications registered in login page (iOS)');
            } else if (permStatus.receive === 'prompt') {
              // If not yet asked, request it
              await this.registerNotifications();
            }
          }
        } catch (error) {
          console.error('Error handling push notification permission in login:', error);
        }
      }, 2000);
    }
  }

  ionViewWillLeave() {
  }

  registerNotifications = async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping push notification registration');
      return;
    }

    try {
      let permStatus = await PushNotifications.checkPermissions();
      console.log('Push notification permission status:', permStatus.receive);

      // If permission is already granted, just register
      if (permStatus.receive === 'granted') {
        await PushNotifications.register();
        console.log('Push notifications registered (already granted)');
        return;
      }

      // If permission is denied, don't request again
      if (permStatus.receive === 'denied') {
        console.log('Push notification permission denied, skipping request');
        return;
      }

      // If permission is prompt (not yet asked), request it
      if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
        console.log('Requesting push notification permission...');
        // For Android, add a delay to ensure UI is ready
        if (this.platform.is('android')) {
          await new Promise(resolve => setTimeout(resolve, 500));
        } else {
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        
        permStatus = await PushNotifications.requestPermissions();
        console.log('Push notification permission request result:', permStatus.receive);

        if (permStatus.receive === 'granted') {
          await PushNotifications.register();
          console.log('Push notifications registered (newly granted)');
        } else if (permStatus.receive === 'prompt-with-rationale' && this.platform.is('android')) {
          // Android specific: if rationale is needed, try again after a delay
          console.log('Android prompt-with-rationale, will retry after delay...');
          setTimeout(async () => {
            try {
              const retryStatus = await PushNotifications.requestPermissions();
              console.log('Android push notification retry result:', retryStatus.receive);
              if (retryStatus.receive === 'granted') {
                await PushNotifications.register();
                console.log('Push notifications registered after retry');
              }
            } catch (error) {
              console.error('Error retrying push notification permission:', error);
            }
          }, 2000);
        }
      }
    } catch (error) {
      console.error('Error registering push notifications:', error);
    }
  }

  private ensureTerms(): boolean {

    let tempURL = document.URL;
    let isDeepLink: boolean = tempURL.includes("referralUserId") || tempURL.includes("unsubscribe")

    if (AppComponent.isUnsubscribe || isDeepLink) {
      AppComponent.isUnsubscribe = false;
      return true;// No need to show terms for unsubscribe
    }

    if (this.userData != null && this.userData.termsAcceptedOn != null) {
      Preferences.set({ key: 'TERMS_ACCEPTED_ON', value: JSON.stringify(this.userData.termsAcceptedOn) }).then((val) => {
        console.log('termsAcceptedOn saved to DB');
      });
      return true;
    }


    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      console.log('val inside ensureTerms: ' + val);

      if (val != null) {
        this.userData = val;
        console.log('val inside ensureTerms: ' + val);
        if (this.userData.termsAcceptedOn != null) {
          Preferences.set({ key: 'TERMS_ACCEPTED_ON', value: JSON.stringify(this.userData.termsAcceptedOn) }).then((val) => {
            console.log('termsAcceptedOn saved to DB');
          });
          return true;
        } else {
          Preferences.get({ key: 'TERMS_ACCEPTED_ON' }).then((val) => {
            val = val.value ? JSON.parse(val.value) : null;
            if (val == null) {
              this.displayLoginShared();
              return false;
            } else {
              this.userData.termsAcceptedOn = val;
              Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
                console.log('userdata saved to DB');
              });
              return true;
            }
          });
        }
      } else {
        console.log('val inside ensureTerms is null. Will determine if termsAcceptedOn is set..');
        Preferences.get({ key: 'TERMS_ACCEPTED_ON' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          console.log('termsAcceptedOn stored: ' + val);
          if (val == null) {
            this.displayTerms();
            return false;
          } else {
            return true;
          }
        });
      }

      return true; //!!!!!!!
    })

    return true;

  }

  private async displayLoginShared() {
    console.log('displayTerms..');
    let modal = this.modalCtrl.create({ component: LoginSharedPage, componentProps: { needsAcceptance: true } });
    (await modal).present();
  }

  private async displayTerms() {
    console.log('displayTerms..');
    let modal = this.modalCtrl.create({ component: TermsComponent, componentProps: { needsAcceptance: true } });
    (await modal).present();

  }


  async ngOnInit() {
    this.getDevice();
  }


  initializeApp() {
    this.platform.ready().then(async () => {
      try {
        await FacebookLogin.initialize({ appId: '990402335013238' });
        console.log('Facebook Login inicializado com sucesso');
      } catch (error) {
        console.error('Erro ao inicializar Facebook Login:', error);
      }
    })
  }

  async getDevice() {
    const device = await Device.getInfo();
    if (this.util.isNative()) {
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: (await App.getInfo()).version,
      };

    } else {
      // Browser
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: webVersion
      }

    }
    this.userModel.device = this.deviceInfo
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: TermsComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //alert(`Hello, ${data}!`);
    }
  }

  public startVideo() {
    console.log(this.isNative);
    console.log(this.isIos);

    if (!localStorage.getItem('USER_LOGGED')) {
      try {
        const videoElement = document.querySelector('video');
        if (videoElement) {
          videoElement.autoplay = true;
          const promise = videoElement.play();
          if (promise !== undefined) {
            promise.then(() => {
              console.log('Autoplay started!');
            }).catch(error => {
              console.log('Autoplay prevented:', error);
              throw new Error('Error in autoplay handling: ' + error.message);
            });
          }
        }

        console.log('Video started playing successfully');
      } catch (error) {
        console.error('Video play error:', error);
      }
    }

  }

  appleSignin() {
    this.processingAppleSignin = true;

    let options: SignInWithAppleOptions = {
      clientId: 'com.leftyapp',
      redirectURI: 'https://app.veggly.net/',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then(async (loginSuccess: SignInWithAppleResponse) => {

        this.loadingCtrl.create({
          message: this.translate.instant('msgOneMomentPlease'),
        });

        let userDataLocal: any = {
          appleUser: loginSuccess.response.user,
        }

        if (loginSuccess.response.givenName != undefined && loginSuccess.response.givenName != null && loginSuccess.response.givenName != null) {
          const fullName = loginSuccess.response.givenName + loginSuccess.response.familyName;
          userDataLocal.firstName = loginSuccess.response.givenName;
          userDataLocal.lastName = loginSuccess.response.familyName;
        }

        userDataLocal.authorizationCode = loginSuccess.response.authorizationCode;
        userDataLocal.identityToken = loginSuccess.response.identityToken;

        if (loginSuccess.response.email !== '') {
          userDataLocal.email = loginSuccess.response.email;
          localStorage.setItem('USER_LOGGED', 'true')
          Preferences.set({ key: 'USER_DATA_APPLE', value: userDataLocal }).then((val) => {
            console.log('userdataapple stored');
          });

        } else {
          await Preferences.get({ key: 'USER_DATA_APPLE' }).then((val) => {
            val = val.value ? JSON.parse(val.value) : null;
            if (val != null) {
              userDataLocal = val;
              localStorage.setItem('USER_LOGGED', 'true')
            }
            console.log('userdataapple that was stored: ' + JSON.stringify(userDataLocal));
          });
        }
        Preferences.get({ key: 'LAST_LOCATION' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          let location = val;
          let teleportationLocation = this.locationService.getTeleportationLocation();
          if (teleportationLocation != null) {
            location = teleportationLocation;
          }


          this.userService.upsertSoul(userDataLocal, location, false, false, true)
            .subscribe(
              {
                next: async (data) => {

                  if (data == '{not ok}') {
                    console.log('upsert subscribe entered');
                    console.log('data returned from upsert: ' + data);
                    if (userDataLocal.email != undefined && userDataLocal.email != null) {

                      let alert = this.alertCtrl.create({
                        subHeader: this.translate.instant('createNewAccount'),
                        message: this.translate.instant('userWithEmailNotFound') + ' <b>' + userDataLocal.email + '</b>. ' + this.translate.instant('wouldYouLikeToCreateNew') + ' <a href="https://www.veggly.net/user-manual/#sign-in-with-apple">' + this.translate.instant('tryingToAccessExisting') + '</a>?',
                        buttons: [
                          {
                            text: this.translate.instant('cancel'),
                            handler: () => {
                              this.loadingCtrl.dismiss();
                              this.processingAppleSignin = false;
                            }
                          },
                          {
                            text: this.translate.instant('confirm'),
                            handler: () => {
                              userDataLocal.createConfirmed = true;
                              this.userService.upsertSoul(userDataLocal, location, false, false, true).subscribe(
                                {
                                  next: async (data) => {
                                    console.log('createConfirmed upsert subscribe entered');
                                    console.log('data returned from createConfirmed upsert: ' + data);

                                    if (data == '{not ok}') {
                                      console.log('createConfirmed Upsert error: ');
                                      return;
                                    }

                                    console.log("============USER APPLE CREATED=========");
                                    console.log(this.userData);

                                    this.userData = JSON.parse(data);

                                    this.registerLoginEvents();
                                    this.saveProfile(null);

                                  },
                                  error: (erro) => {
                                    console.log('Upsert error: ' + JSON.stringify(erro.toString()));
                                    this.loadingCtrl.dismiss();
                                    this.util.showToastUnableToConnect(this.toastCtrl);
                                    this.processingAppleSignin = false;
                                  }
                                }
                              );
                              return;
                            }
                          }
                        ]
                      });
                      (await alert).present();

                    } else { // No email was sent to server. User already signed in on device and account not found in our server
                      let alert = this.alertCtrl.create({
                        subHeader: this.translate.instant('accountNotFoundOnVeggly'),
                        message: this.translate.instant('ifYouWouldLikeNewStopAppleId'),
                        buttons: [
                          {
                            text: 'OK',
                            handler: () => {
                              //this.loader.dismiss();
                            }
                          }
                        ]
                      });
                      (await alert).present();
                    }

                  } else {

                    let resultJSON: any = JSON.parse(data);
                    if (resultJSON.login != undefined && resultJSON.login != null && resultJSON.login == 'invalid') {
                      this.showModalAlert(this.translate.instant('invalidLogin'));
                      this.processingAppleSignin = false;
                      return;
                    } else {

                      this.userData = resultJSON;
                      this.userModel = this.userData;

                      this.registerLoginEvents();
                      this.saveProfile(null);
                    }
                  }
                },
                error: (erro) => {
                  console.log(erro);
                  this.processingAppleSignin = false;
                }
              }
            )
        },
          error => {
            console.error(JSON.stringify(error))
            console.log(JSON.stringify(error))
            this.processingAppleSignin = false;
          });

      }, (reason: any) => {
        console.log(reason);
        this.processingAppleSignin = false;
      })
      .catch(error => {
        console.error(JSON.stringify(error))
        console.log(JSON.stringify(error))
        this.processingAppleSignin = false;
      });


  }

  async appleSigninNew() {
    // const loading = await this.loadingCtrl.create({
    //   message: 'Dismissing after 3 seconds...',
    //   duration: 3000,
    // });
    // loading.present();

    let options: SignInWithAppleOptions = {
      clientId: 'com.leftyapp',
      redirectURI: 'https://app.veggly.net/',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then((result: SignInWithAppleResponse) => {

      })
      .catch(error => {
        // Handle error
      });

  }

  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      translucent: true,

      backdropDismiss: true
    });

    loading.present();
  }

  async googleSignIn() {
    this.processingGoogleSignin = true;

    try {
      console.log('Iniciando login do Google...');

      let clientId: string = '';

      if (!Capacitor.isNativePlatform()) {
        clientId = environment.googleAuth.web;
        console.log('Plataforma: Web, Client ID:', clientId);
      } else if (this.isIos) {
        clientId = environment.googleAuth.ios;
        console.log('Plataforma: iOS, Client ID:', clientId);
      } else {
        clientId = environment.googleAuth.android;
        console.log('Plataforma: Android, Client ID:', clientId);
      }

      // Verificar se o clientId está definido
      if (!clientId) {
        throw new Error('Google Auth Client ID não encontrado');
      }

      console.log('Inicializando Google Auth...');
      console.log('Client ID sendo usado:', clientId);
      console.log('Server Client ID:', environment.googleAuth.web);

      await GoogleAuth.initialize({
        clientId: clientId,
        scopes: ['profile', 'email'],
        grantOfflineAccess: true,
      });
      console.log('Google Auth inicializado com sucesso');

      console.log('Tentando fazer login...');

      // Tentar fazer login com retry
      let googleUser;
      try {
        googleUser = await GoogleAuth.signIn();
        console.log('Google Authentication Result:', googleUser);
      } catch (signInError) {
        console.error('Erro no Google Sign In:', signInError);
        throw new Error('Falha no login do Google');
      }
      // Handle authentication success
      if (googleUser.email == undefined || googleUser.email == null || googleUser.email == '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        this.processingGoogleSignin = false;
        return;
      }

      this.userData = {
        email: googleUser.email
      };

      if ((googleUser as any).googleUserId != null) {
        this.userData.googleUserId = (googleUser as any).googleUserId
      }
      if (googleUser.name != null) {
        this.userData.displayName = googleUser.name
      }
      if (googleUser.givenName != null) {
        this.userData.firstName = googleUser.givenName
      }
      if (googleUser.familyName != null) {
        this.userData.lastName = googleUser.familyName
      }
      if (googleUser.authentication.refreshToken != null) {
        this.userData.googleRefreshToken = googleUser.authentication.refreshToken
      }
      if (googleUser.serverAuthCode != null) {
        this.userData.googleServerAuthCode = googleUser.serverAuthCode
      }

      if (googleUser.authentication.accessToken != null) {
        this.userData.googleAccessToken = googleUser.authentication.accessToken
      }
      if (googleUser.authentication.idToken != null) {
        this.userData.googleIdToken = googleUser.authentication.idToken
      }

      console.log('Dados do usuário processados:', this.userData);
      this.registerLoginEvents();
      this.saveProfile(null);

    } catch (error) {
      console.error('Google Authentication Error:', error);

      // Tratamento específico para diferentes tipos de erro
      let errorMessage = 'Erro desconhecido';

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else if (error && typeof error === 'object') {
        errorMessage = (error as any).message || JSON.stringify(error);
      }

      // Logs específicos para debugging em produção
      console.error('Google Auth Error Details:', {
        message: errorMessage,
        platform: Capacitor.isNativePlatform() ? (this.isIos ? 'iOS' : 'Android') : 'Web',
        clientId: environment.googleAuth[Capacitor.isNativePlatform() ? (this.isIos ? 'ios' : 'android') : 'web'],
        timestamp: new Date().toISOString()
      });

      this.showModalAlert('Erro no login do Google: ' + errorMessage);
      this.processingGoogleSignin = false;
    }
  }

  async loginWithFB() {
    this.processingFacebookSignin = true;
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      duration: 3000,
    });

    try {
      loading.present();

      console.log('Iniciando login do Facebook...');

      // Primeiro, inicializar o Facebook se necessário
      try {
        await FacebookLogin.initialize({ appId: '990402335013238' });
        console.log('Facebook inicializado com sucesso');
      } catch (initError) {
        console.log('Facebook já inicializado ou erro de inicialização:', initError);
      }

      // Tentar fazer login
      const accessToken = await this.facebookService.login();
      console.log('Access Token obtido:', accessToken ? 'Sim' : 'Não');

      if (accessToken) {
        // Obter dados do usuário
        let facebookUser: FacebookUser = await this.facebookService.getUserData();
        console.log('User Data:', facebookUser);

        this.userData = facebookUser;
        this.registerLoginEvents();

        if (facebookUser['picture'] && facebookUser['picture']['data'] && facebookUser['picture']['data']['url']) {
          this.saveProfile(facebookUser['picture']['data']['url']);
        } else {
          this.saveProfile(null);
        }
      } else {
        console.error('Falha no login do Facebook - sem access token');
        this.showModalAlert('Erro no login do Facebook. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro detalhado no login do Facebook:', error);
      this.showModalAlert('Erro no login do Facebook: ' + ((error as any).message || 'Erro desconhecido'));
    } finally {
      this.processingFacebookSignin = false;
      loading.dismiss();
    }
  }




  private async saveProfile(localPicture: any) {
    console.log('=== saveProfile iniciado ===');
    console.log('userData:', this.userData);

    const lastLocation = await Preferences.get({ key: 'LAST_LOCATION' });
    let location = lastLocation?.value ? JSON.parse(lastLocation.value) : { type: 'Point', coordinates: [environment.locationDefault.coordinates[0], environment.locationDefault.coordinates[1]] };
    let teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      location = teleportationLocation;
    }

    console.log('location:', location);
    console.log('environment.mainServer:', environment.mainServer);

    // Retrieve and add FCM token to userData before sending to server
    console.log('=== Attempting to retrieve FCM token ===');
    let tokenValue = null;

    // Try Preferences first
    const fcmToken = await Preferences.get({ key: 'TOKEN' });
    if (fcmToken && fcmToken.value) {
      tokenValue = fcmToken.value;
      console.log('FCM token found in Preferences:', tokenValue);
    } else {
      console.log('No FCM token in Preferences, checking localStorage');
      // Fallback to localStorage
      const localToken = localStorage.getItem('TOKEN');
      if (localToken) {
        tokenValue = localToken;
        console.log('FCM token found in localStorage:', tokenValue);
      } else {
        console.log('No FCM token found in either storage location');
      }
    }

    if (tokenValue) {
      this.userData.token = tokenValue;
      console.log('FCM token successfully added to userData');
      console.log('userData object before upsertSoul:', JSON.stringify(this.userData));
    }

    this.userService
      .upsertSoul(this.userData, location, false, false, true)
      .subscribe(
        {
          next: async (data) => {
            console.log('=== upsertSoul sucesso ===');
            console.log('Resposta do servidor:', data);
            if (data != '{not ok}') {
              this.userModel = JSON.parse(data);

              // Send image to Server
              let serverPicture = this.userData.picture0;

              if (localPicture != null && serverPicture == null) {
                this.userData = JSON.parse(data);
                this.http.get(localPicture, { responseType: 'blob' })
                  .subscribe(
                    {
                      next: (response: Blob) => {
                        const fileReader = new FileReader();
                        const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
                        const reader = zoneOriginalInstance || fileReader;

                        reader.onloadend = async () => {
                          let uploadImageFB = this.setFirstPicture();
                          if (uploadImageFB) {
                            this.imageFB = reader.result as string;
                            let filename: string = 'picture' + 0;
                            this.userService
                              .uploadImage64(this.imageFB, this.userModel, filename)
                              .subscribe(
                                {
                                  next: async (data) => {
                                    this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                                    this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                                    this.userModel.filename = { '$oid': data };
                                    this.userModel.picture0 = { '$oid': data };
                                    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
                                      this.storeUserLocally();
                                    });
                                  },
                                  error: (err) => {
                                    //alert('uploadImage error: ' + JSON.stringify(err));
                                  }
                                }
                              )
                          } else {
                            this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                            this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                            await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
                              this.storeUserLocally();
                            });
                          }

                        }


                        reader.readAsDataURL(response);

                      },
                      error: (erro) => {
                        //alert("Usuário ou Senha inválido(s)!");
                        console.log(erro)
                      }
                    }
                  )
              } else {
                this.userData = JSON.parse(data);
                await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
                  this.storeUserLocally();
                });
              }
            }
          },
          error: (erro) => {
            console.log('=== upsertSoul erro ===');
            console.log('Erro completo:', erro);
            console.log('Status:', erro.status);
            console.log('Mensagem:', erro.message);
            console.log('URL:', erro.url);
            //alert("Usuário ou Senha inválido(s)!");
            console.log(erro)
            this.processingGoogleSignin = false;
            this.processingFacebookSignin = false;
            this.processingAppleSignin = false;
          }
        }
      )



  }

  setFirstPicture() {
    let picnum: number;
    let picCount: number = 0;
    let data2: any = this.userModel
    for (picnum = 0; picnum < 9; picnum++) {
      let aPic: string = "picture" + picnum;
      if (data2[aPic]) {
        picCount++;
      }
    }
    if (picCount == 0) {
      return true;
    }
    return false
  }




  async showModalAlert(message: string) {
    let alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }

  showWelcomeBackMsg() {
    if (this.userModel.wasOnHibernate != null) {
      this.showModalAlert(this.translate.instant('welcomeBackFromHibernate'));
      delete this.userModel.wasOnHibernate;

      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
        console.log('login.showWelcomeBackMsg: saved user without the wasOnHibernate');
      });
    }
  }

  private async storeUserLocally() {
    // Store locally
    console.log('Stored UserData = ' + JSON.stringify(this.userData));
    
    // Restore teleportation location from local storage if it exists (before setting USER_DATA)
    const savedTeleportLocation = await Preferences.get({ key: 'TELEPORT_LOCATION' });
    if (savedTeleportLocation && savedTeleportLocation.value) {
      const teleportLocation = JSON.parse(savedTeleportLocation.value);
      console.log('storeUserLocally: Restoring teleportation location from local storage: ' + JSON.stringify(teleportLocation));
      
      // Restore teleportation location to LocationService
      (this.locationService as any).teleportLocation = teleportLocation;
      
      // If server response doesn't have teleportation info, restore it from local storage
      if (this.userModel) {
        if (!this.userModel.usingTeleportation || !this.userModel.location) {
          console.log('storeUserLocally: Server response missing teleportation info, restoring from local storage');
          this.userModel.usingTeleportation = true;
          this.userModel.location = teleportLocation;
        }
      }
    }
    
    // If user is using teleportation and server response has location, save it to TELEPORT_LOCATION
    if (this.userModel && this.userModel.usingTeleportation && this.userModel.location) {
      console.log('storeUserLocally: User is using teleportation, saving location to TELEPORT_LOCATION: ' + JSON.stringify(this.userModel.location));
      await Preferences.set({ key: 'TELEPORT_LOCATION', value: JSON.stringify(this.userModel.location) });
      console.log('TELEPORT_LOCATION saved to Preferences');
      // Update LocationService in-memory cache
      (this.locationService as any).teleportLocation = this.userModel.location;
    }
    
    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((val) => {
      //this.fcm.getToken();
      console.log('Will set UserService.loggedOut to false. Current value: ' + UserService.loggedOut);
      UserService.loggedOut = false;
      this.processingGoogleSignin = false;
      this.processingFacebookSignin = false;
      this.processingAppleSignin = false;
      this.restartMatchService();
      localStorage.setItem('USER_LOGGED', 'true')
      Preferences.set({ key: 'USER_LOGGED', value: 'true' }).then(() => {
        console.log("userLogged saved to DB");
      });
      this.showWelcomeBackMsg();
      
      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
        console.log('userModel saved to Preferences with new location');
        Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
          val = val.value ? JSON.parse(val.value) : null;

          console.log("val.interest:", val.interest2);

          if (val.interest2 != null) {
            console.log(this.userData.interest2);
            this.router.navigateByUrl('/tabs/home');
          } else {
            console.log(this.userData.interest2);
            this.router.navigateByUrl('/tabs/my-profile-display');
          }

        });
      });
    });
  }

  registerLoginEvents() {
    // Your logic for registering login events
    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (this.userService.checkUserHasPicture(val)) {
        this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
        if (val.sign_up_compl_ok)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpComplOk, true);
        if (val.valuable_user)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable, true);
      }
    })
  }

  async openProfile() {
    this.router.navigateByUrl('/tabs/home');
  }
  async openDefaultLogin() {
    this.router.navigateByUrl('/default-login');
  }


  private restartMatchService() {
    this.matchService.restartRefresh();
  }
}